function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.14287,
  y: 1,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4286,
  y: 1,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 4.14287,
  y: 10.4286,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 7.28572,
  y: 7.28572,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4286,
  y: 7.28572,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5714,
  y: 7.28572,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5714,
  y: 10.4286,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5714,
  y: 13.5714,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5714,
  y: 16.7143,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 16.7143,
  y: 16.7143,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 19.8571,
  y: 16.7143,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 19.8571,
  y: 19.8571,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 19.8571,
  y: 10.9524,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4286,
  y: 19.8571,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4286,
  y: 13.5714,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 7.28572,
  y: 13.5714,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 4.14287,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 4.14287,
  y: 4.14287,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 16.7143,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 4.14287,
  y: 16.7143,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 19.8571,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 4.14287,
  y: 19.8571,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 16.7143,
  y: 1,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 19.8571,
  y: 1,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 16.7143,
  y: 4.14287,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 19.8571,
  y: 4.14287,
  width: 3.14286,
  height: 3.14286,
  fill: "#627080"
});

const SvgQr = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QR.d58258fe.svg";
export { ForwardRef as ReactComponent };